import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getTopRelationshipTypeChanges';

export const getTopRelationshipTypeChanges = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
